import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, finalize, catchError, map, switchMap } from 'rxjs/operators';
import { ContractModificationDTO, ProjectEntityDTO, ValidationResultDTO, ResultTypeDTO, ObjectContextDTO, BudgetAccountLineDTO, ActionParameterDefinitionDTO, ProjectRelationDTO, CofinancingLineDTO } from '../../api/plyca-dtos-v2';
import { Observable, of, ObservableInput, forkJoin, throwError } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import { InterfaceSettings } from '../../api/contract-notice-dto';
import { FormConfig } from '../../components/forms/form.objects';
import { SearchSelectionResultDTO, WorkContractMoficationDTO } from '../../api/plyca-dtos';
import { ContractModificationValidations } from './contractModification.validation';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { PropertyService } from '../../properties/property.service';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';



@Component({
  selector: 'contractModification-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html',
  providers: [ContractModificationValidations]
})

export class ContractModificationComponent
  extends BaseFormComponent<ContractModificationDTO, ContractModificationDTO>
  implements OnInit, OnDestroy {
  private identifier: string;
  // private formService: FormService;

  propertyService: PropertyService;
  //Indica si se pueden añadir partidas presupuestarias o se hace a través de un buscador.
  canAddBudgetAccountLine: boolean;
  activedProject: boolean;

  // Identificador de incidencia
  private type: string; // Tipo de la incidencia
  private projectIdentifier: string; // Identiificador del expediente
  private contractDivision: string; // Division padre de la incidencia
  private workContractModification: WorkContractMoficationDTO; // Tarea de la incidencia
  private contexWork: ObjectContextDTO; // Contexto de la tarea de la incidencia
  private cmReplycaAdapted: boolean; //Indica si hay adaptación propia para incidencias de REPLYCA.

  @Input()
  project: ProjectEntityDTO;

  constructor(
    public configuration: Configuration,
    private contractModificationValidations: ContractModificationValidations,
    elem: ElementRef,
    public router: Router,
    @Optional() protected activatedRoute: ActivatedRoute,
    public helpService: HelpService,
    private plycaErrorHandler: PlycaErrorHandler
  ) {
    super(elem);

  }


  ngOnInit(): void {
    let helpTags = [];
    if (this.task) {
      helpTags = helpTags.concat([HelpType.NEW_CONTRACTMODIFICATION, 'INCIDENCIA_' + this.task.work.contractModification.alias]);

      console.log('INVOCACION DE CONTRACTMODIFICATION DESDE TAREA', this.task);
      // ayuda con tarea
      this.subscribe(this.helpService.getStoreTagsObservable().pipe(
        switchMap((taskHelpTags) => {
          helpTags = taskHelpTags.concat(helpTags);
          return this.helpService.showContextHelpObservable(helpTags)

        })));

      this.workContractModification = this.task.work;
      this.identifier = this.task.work.contractModification.identifier;
      this.projectIdentifier = this.task.work.contractModification.division.parent.project.identifier;
      let contractDiv = this.task.work.contractModification.division.parent.identifier;
      this.contractDivision = contractDiv.toString().substring(0, contractDiv.indexOf('<>'));

      super.ngOnInit();
    } else {

      this.subscribe(this.activatedRoute.params
        .pipe(tap(params => (this.identifier = params['id']))));
      this.activatedRoute.queryParams.subscribe(params => {
        this.projectIdentifier = params['projectIdentifier'];
        this.contractDivision = params['contractDivision'];
        this.type = params['type'];
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.NEW_CONTRACTMODIFICATION, 'INCIDENCIA_' + this.type]));

      });
      super.ngOnInit();
    }
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  private ignoreError(e: any, channeFormURL: string): ObservableInput<InterfaceSettings> {
    console.error('Error al obtener definicion del formulario ' + channeFormURL);
    return of(undefined);
  }

  private newFormConfig(): FormConfig {
    let formConfig: FormConfig;
    formConfig = new FormConfig('contractModifications/contractModificationInterfaceSettings_.json', undefined, this.model);
    return formConfig;
  }

  createFormConfig(): Observable<FormConfig> {
    let dto = this.model;
    let baseFormURL = this.getFormSettingURL();
    let contractModificationForm: Observable<InterfaceSettings>;
    // let contractModificationBudgetForm: Observable<InterfaceSettings>;
    let contractModificationFormURL = baseFormURL.substring(0, baseFormURL.indexOf('.json')) + '_' + this.type + '.json';
    // let contractModificationBudgetFormURL = 'contractModifications/contractModificationBudgetInterfaceSettings.json';
    contractModificationForm = this.plycaService.getInterfaceSettings(contractModificationFormURL, true).pipe(
      catchError((e: any) => this.ignoreError(e, contractModificationFormURL))
    );

    // Panel de importes
    let contractModificationBudgetFormURL = 'contractModifications/contractModificationBudgetInterfaceSettings.json';
    let contractModificationBudgetForm: Observable<InterfaceSettings>;

    contractModificationBudgetForm = this.plycaService.getInterfaceSettings(contractModificationBudgetFormURL).pipe(
      catchError((e: any) => this.ignoreError(e, contractModificationBudgetFormURL))
    );

    // Panel de plazos
    let contractModificationDeadLineFormURL = 'contractModifications/contractModificationDeadLineInterfaceSettings.json';
    let contractModificationDeadLineForm: Observable<InterfaceSettings>;

    contractModificationDeadLineForm = this.plycaService.getInterfaceSettings(contractModificationDeadLineFormURL).pipe(
      catchError((e: any) => this.ignoreError(e, contractModificationDeadLineFormURL))
    );
    /*
      En los json:

    {
      "id": "data_group_budget",
      "adaptConfig": {
        "operation": "INSERT",
        "after": "data_group_PRC"
      },
      "visibility": "false",
      "fieldList": []
    }

    */
    return forkJoin(
      this.plycaService.getInterfaceSettings(baseFormURL),
      contractModificationForm,
      contractModificationBudgetForm,
      contractModificationDeadLineForm
    ).pipe(
      map((result: InterfaceSettings[]) => {
        let mergedInterfacceSettings = result[0];
        let interfaceToMerge = result[1];
        if (interfaceToMerge) {
          mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
        }
        if ((this.type === 'MDC' || this.type === 'PRC') && !this.cmReplycaAdapted) {
          interfaceToMerge = result[2];
          if (interfaceToMerge) {
            mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
          }
        }
        if (this.type === 'MDC') {
          interfaceToMerge = result[3];
          if (interfaceToMerge) {
            mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
          }
        }
        let formConfig = this.newFormConfig();
        formConfig.interfaceSetting = mergedInterfacceSettings;
        formConfig.isModalWindow = false;
        formConfig.showValidations = true;
        // this.loadFunctions(formConfig);
        return formConfig;
      }),
      finalize(() => { console.log('Creado') })
    );
    // if que comprueba en el contexto si las anualidades son visibles.
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    this.loadFunctions(formConfig);
    return super.configureFormConfig(formConfig);
  }

  getFormSettingURL(): string {
    let isAutomaticMode = true;
    if (this.model && this.model.context
      && this.model.context.configurations &&
      this.model.context.configurations.isAutomaticMode) {
      isAutomaticMode = this.model.context.configurations.isAutomaticMode.value;
    }
    if (!isAutomaticMode && this.model && this.model.context
      && this.model.context.configurations &&
      this.model.context.configurations.formReplyca) {
      this.cmReplycaAdapted = true;
      return this.model.context.configurations.formReplyca.value;
    } else {
      // Se le concatena el tipo de la incidencia, para abrir la incidencia adecuada
      return 'contractModifications/contractModificationInterfaceSettings.json';
      // return 'contracts/contractModificationInterfaceSettings_' + this.type + '.json';
    }
  }

  getServiceURL(): string {
    return this.configuration.CONTRACT_MODIFICATIONS_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    if (this.task) {
      return undefined;
    } else if (this.identifier === 'new') {
      return this.identifier + '?projectIdentifier=' + this.projectIdentifier + '&contractDivision='
        + this.contractDivision + '&type=' + this.type;
    } else {
      return this.identifier;
    }
  }

  dtoToModel(dto: ContractModificationDTO): Observable<ContractModificationDTO> {
    // SERVIDOR A CLIENTE

    if (dto.alias) {
      this.type = dto.alias;
    }

    // Se establecen las configueraciones del conteexto de tarea
    this.setUIConfigurations(dto, this.workContractModification);
    return of(dto);
  }

  normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }

  setUIConfigurations(dto: ContractModificationDTO, workContractModification: WorkContractMoficationDTO) {
    // Se inicializa el UI
    dto['ui'] = {};

    // Se inicializan los valores por defecto en el caso de que no vengan de tarea
    dto['ui'].visibleAgreementDate = false;
    dto['ui'].visibleStartDate = false;
    dto['ui'].visibleEndDate = false;
    dto['ui'].enabledBudgetAccountLine = true;
    dto['ui'].enabledReason = true;
    dto['ui'].enabledNote = true;
    dto['ui'].newProjectId = this.normalizaDossierId(dto.division.parent.project.identifier);
    if (dto.context.configurations['enabledLots']) {
      dto['ui'].enabledLot = dto.context.configurations['enabledLots'].value;
    }

    dto['ui'].projectIdentifier = '';
    dto['ui'].contractDivision = '';

    if (this.projectIdentifier) {
      dto['ui'].projectIdentifier = this.projectIdentifier;
    }
    if (this.contractDivision) {
      dto['ui'].contractDivision = this.contractDivision;
    }


    // Se inicializan las configuraciones de tarea
    if (this.workContractModification && this.workContractModification.context
      && this.workContractModification.context.configurations != undefined) {
      this.contexWork = this.workContractModification.context;

      ///// Se establecen las configuraciones que viene desde tarea//////

      // Fecha del Acuerdo
      if (this.contexWork.configurations['visibleAgreementDate']) {
        let visibleAgreementDate = this.contexWork.configurations['visibleAgreementDate'].value;
        if (visibleAgreementDate != undefined && visibleAgreementDate != '' && visibleAgreementDate != null) {
          dto['ui'].visibleAgreementDate = true;
        }

        if (this.contexWork.configurations['agreementDate'] != undefined) {
          let agreementDate = this.contexWork.configurations['agreementDate'].value;
          if (agreementDate != undefined && agreementDate != '' && agreementDate != null) {
            dto.plannedPeriod.agreementDate = agreementDate;
          }
        }
      }


      if (this.type === 'SSC' || this.type === 'SIC') {
        // Las incidencias de SSC Y SIC se comportan casi como un visualizar en este caso
        // unicamente se habilita la Fecha de Inicio y la Fecha de Fin

        // Fecha de Inicio
        if (this.contexWork.configurations['visibleStartDate']) {
          let visibleStartDate = this.contexWork.configurations['visibleStartDate'].value;
          if (visibleStartDate != undefined && visibleStartDate != '' && visibleStartDate != null) {
            dto['ui'].visibleStartDate = true;
          }
        }
        // Fecha de Fin

        if (this.contexWork.configurations['visibleEndDate']) {
          let visibleEndDate = this.contexWork.configurations['visibleEndDate'].value;
          if (visibleEndDate != undefined && visibleEndDate != '' && visibleEndDate != null) {
            dto['ui'].visibleEndDate = true;
          }
        }

        if (this.contexWork.configurations['enabledBudgetAccountLine']) {
          // Anualidades
          dto['ui'].enabledBudgetAccountLine = this.contexWork.configurations['enabledBudgetAccountLine'].value;
        }

        // Objeto de la incidencia
        if (this.contexWork.configurations['enabledReason']) {
          dto['ui'].enabledReason = this.contexWork.configurations['enabledReason'].value;
        }
        // Observaciones de la incidencia
        if (this.contexWork.configurations['enabledReason']) {
          dto['ui'].enabledNote = this.contexWork.configurations['enabledNote'].value;
        }

      }
    }
  }

  getDataObservable(): ContractModificationDTO {
    if (this.workContractModification
      && this.workContractModification.contractModification) {
      return this.workContractModification.contractModification;
    }
    return undefined;
  }

  modelToDTO(model: ContractModificationDTO): ContractModificationDTO {
    // CLIENTE A SERVIDOR
    model = JSON.parse(
      JSON.stringify(model, (k, v) => (k === '_parent' ? undefined : v))
    );
    model.origin = 'FI';
    if (this.task !== undefined) {
      this.task.work.contractModification = model;
    }
    return model;
  }

  getTitle(model: ContractModificationDTO): string {
    if (model) {
      return model.identifier + ' - ';
    } else {
      return 'Nuevo grupo';
    }

  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Ficha de Incidencia';
    headerInfo.titleIcon = 'fas fa-file-invoice';

    if (this.model && this.model.division && this.model.division.parent && this.model.division.parent.project) {
      headerInfo.project = this.model.division.parent.project;
    }
    return headerInfo;
  }

  initHeaderActions() {
    if (this.task || this.isContractModificationEditable()) {
      this.subscribe(this.headerActionsService.addAction('General.save', 'fas fa-save', 'btn-primary', true),
        () => {
          let dto = this.modelToDTO(this.model);
          if (this.task) {
            this.subscribe(this.saveIfValidContext(true, dto, this.getValidationContext()));
          } else {
            this.waitService.startWaiting();

            this.subscribe(super.saveIfValidContext(false, dto, this.getValidationContext()),
              (result: any) => {
                if (!result || !this.formService.isValidationResponse(result)) {
                  // Si todo ok se consulta si hay que tramitar
                  let identifier = this.model.identifier ? this.model.identifier : result.identifier;
                  this.subscribe(
                    this.plycaService.get<ContractModificationDTO>(
                      this.configuration.CONTRACT_MODIFICATIONS_SERVICE_URL,
                      identifier),
                    (_contractModification: ContractModificationDTO) => {
                      this.waitService.cancelWaiting();
                      this.showConfirmMessage(_contractModification);
                    },
                    (error) => {
                      this.waitService.cancelWaiting();
                      this.plycaErrorHandler.showServerError(error);

                    });
                } else {
                  this.waitService.cancelWaiting();
                }
              },
              (error) => {
                this.waitService.cancelWaiting();
                this.plycaErrorHandler.showServerError(error);

              }
            );
          }

        }

      );
      this.headerActionsService.addDivider();
    }
    this.addBackAction();
  }


  getValidationContext() {
    let nameValidation = '';
    let isAutomaticMode = true;
    if (this.model && this.model.context
      && this.model.context.configurations &&
      this.model.context.configurations.isAutomaticMode) {
      isAutomaticMode = this.model.context.configurations.isAutomaticMode.value;
    }
    if (!isAutomaticMode) {
      if (this.model && this.model.context && this.model.context.configurations &&
        this.model.context.configurations.validateReplyca) {
        nameValidation = this.model.context.configurations.validateReplyca.value;
      }
    } else {
      if (this.model && this.model.context && this.model.context.configurations &&
        this.model.context.configurations.validateCont) {
        nameValidation = this.model.context.configurations.validateCont.value;
      }
    }
    let validationCtx = this.model.identifier ? (nameValidation + 'Update') : (nameValidation + 'Insert');
    return validationCtx;
  }



  private setFormConfig(_contractModification: ContractModificationDTO) {
    let newForm = {} as FormConfig;
    newForm.interfaceSetting = this.formConfig.interfaceSetting;
    newForm.model = _contractModification;
    newForm.functions = this.formConfig.functions;
    newForm.isModalWindow = this.formConfig.isModalWindow;
    newForm.showValidations = this.formConfig.showValidations;
    this.loadFunctions(newForm);
    this.formConfig = newForm;
  }


  protected saveContractModification(showWait = true): void {
    let validationError = false;
    let validationFatal = false;

    if (showWait) {
      this.waitService.startWaiting();
    }

    this.subscribe(this.validate(false), (validation: ValidationResultDTO) => {
      if (validation.result === ResultTypeDTO.FATAL) {  // Si el error es de tipo FATAL, NO permite grabar
        validationFatal = true;
      } else if (validation.result === ResultTypeDTO.ERROR) {// Si el error es de tipo ERROR, permite grabar y se puede cerrar la pantalla
        validationError = true;
      } else {// Si no hay errores permite iniciar la tramitación // OK, o errores de TIPO WARNING
        validationError = false;
      }

      if (!validationFatal) {
        // Para que coja los cambios que tiene por pantalla
        this.subscribe(this.save(false), _model => {
          if (!_model && this.model.identifier) {
            this.subscribe(this.plycaService.get<ContractModificationDTO>(
              this.configuration.CONTRACT_MODIFICATIONS_SERVICE_URL,
              this.model.identifier),
              (_contractModification: ContractModificationDTO) => {
                Object.assign(this.model, _contractModification);
                this.setFormConfig(_contractModification);
              });
          } else {
            if (_model) {
              Object.assign(this.model, _model);
              this.setFormConfig(_model);
            }
          }

          if (validationError) {// Aceptar o Cancelar
            this.showConfirmMessageError(this.model);
          } else {// Desea iniciar la tramitación
            this.showConfirmMessage(this.model);
          }

        });
      }
    },
      (error: any) => console.error(error),
      () => {
        if (showWait) {
          this.waitService.cancelWaiting();
        }
      });
  }


  showConfirmMessageError(_contractModification: ContractModificationDTO) {
    this.uiService.showConfirmMessage({

      // 'No se podrá iniciar la tramitación de la incidencia, hasta que se completen todos los datos obligatorios',
      message: this.translateService.instant('ContractModification.message_error_start_processing'),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.goToDossierInfo(_contractModification);
        console.log('Saliendo...');
      }
    });
  }

  showConfirmMessage(_contractModification: ContractModificationDTO) {
    this.uiService.showConfirmMessage({
      // ¿Desea iniciar la tramitación de la incidencia?
      message: this.translateService.instant('ContractModification.message_start_processing'),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.waitService.startWaiting();
        this.subscribe(this.plycaService.startContractModification(_contractModification)
          .pipe(
            finalize(() => {
              this.waitService.cancelWaiting();
            })
          ),
          () => {
            this.goToDossierInfo(_contractModification);
          },
          () => {
            console.log('Error');
          }
        );
      },
      reject: () => {
        this.goToDossierInfo(_contractModification);
        console.log('Saliendo...');
      }
    });
  }

  goToDossierInfo(_contractModification: ContractModificationDTO) {
    this.router.navigate(['dossierInfo/' + _contractModification.division.project.identifier], {
      queryParams: { component: 'CONTRACTS' }
    });
  }

  isContractModificationEditable() {
    let _contactModification = this.model;
    if (_contactModification && _contactModification.document) {
      // console.log('------ version del documento:', _contactModification.document.currentState.identifier);
      return _contactModification.document.currentState.identifier === '17';
      // return true;
    } else {
      return true;
    }
  }

  loadFunctions(_formConfig: FormConfig) {
    console.log('loadFunctions');

    _formConfig.functions.push({
      identifier: 'enabledTaxRate',
      fn: this.contractModificationValidations.enabledTaxRate
    });

    _formConfig.functions.push({
      identifier: 'enabledBudgetTotalTaxes',
      fn: this.contractModificationValidations.valueBudgetTotalTaxes
    });

    _formConfig.functions.push({
      identifier: 'isPublicSector',
      fn: this.contractModificationValidations.isPublicSector
    });

    _formConfig.functions.push({
      identifier: 'valueBudgetTaxType',
      fn: this.contractModificationValidations.valueBudgetTaxType
    });

    _formConfig.functions.push({
      identifier: 'visibleRegistrationNumber',
      fn: this.contractModificationValidations.visibleRegistrationNumber
    });

    _formConfig.functions.push({
      identifier: 'setTotalAmount',
      fn: this.contractModificationValidations.setTotalAmount
    });
    _formConfig.functions.push({
      identifier: 'addBudgetAccountLine',
      fn: this.addBudgetAccountLine
    });
    _formConfig.functions.push({
      identifier: 'addCofinancedLine',
      fn: this.addCofinancedLine
    });
  }

  addCofinancedLine() {
    let config: DynamicDialogConfig = {
      header: 'Buscador cofinancación',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'PROPUESTAID';
    if (this.model.division.project.projectRelations !== undefined) {
      let relationProject = new ProjectRelationDTO();
      relationProject = this.model.division.project.projectRelations[1];
      if (relationProject) {
        param1.value = relationProject.relationsAsSecundary[0].identifier;
      }
    }


    parametersURL.push(param1);

    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'DIVISION';
    //La división de la propuesta de gasto
    param2.value = 0;

    parametersURL.push(param2);

    let autoSearch = true;
    config['context'] = new SearchSettingDTOModal('COFINANCIEDLINE_PROJECT_SEARCH', autoSearch, parametersURL);

    let newRow: CofinancingLineDTO = new CofinancingLineDTO();

    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(
      ref.onClose.pipe(
        tap((result: SearchSelectionResultDTO) => {
          if (result) {
            newRow.budgetYear = result.content.ANOPARTIDA.value;
            //newRow.exercise = result.content.EJERCICIO.value;
            newRow.entity = result.content.DES_ENTIDAD.value;
            newRow.entityDescription = result.content.DES_ENTIDAD.value;
            newRow.project = result.content.IMPORPARTIDA.value;
            return newRow;

          } else {
            console.log('Cerrado sin seleccionar');
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );




    return newRow;
    //return new BudgetAccountLineDTO();
  }
  addBudgetAccountLine() {
    this.subscribe(this.propertyService.getProperty('ACTIVA_DESGLOSE_PARTIDAS_ADJ', '0').pipe(
      finalize(() => { }))
      , (value: string) => {
        this.canAddBudgetAccountLine = value === '1'
      });
    this.subscribe(this.propertyService.getProperty('PROYECTOS_ACTIVOS', '0').pipe(
      finalize(() => { }))
      , (value: string) => {
        this.activedProject = value === '1'
      });
    if (this.canAddBudgetAccountLine && this.model.division.project.relatedProject) {
      let config: DynamicDialogConfig = {
        header: 'Buscador anualidades y existencia de crédito presupuestario',
        width: '70%',
        style: { overflow: 'scroll', 'max-height': '80%' },
        styleClass: 'searchStyle'
      };
      let parametersURL: ActionParameterDefinitionDTO[] = [];

      let param1 = new ActionParameterDefinitionDTO();
      param1.identifier = 'PROPUESTAID';

      if (this.activedProject) {
        //La propuesta del proyecto de gasto

        if (this.model.division.project.projectRelations !== undefined) {
          let relationProject = new ProjectRelationDTO();
          relationProject = this.model.division.project.projectRelations[1];
          if (relationProject) {
            param1.value = relationProject.relationsAsSecundary[0].identifier;
          }
        }
      } else {
        //La división del expediente
        param1.value = this.model.division.project.identifier;
      }

      parametersURL.push(param1);

      let param2 = new ActionParameterDefinitionDTO();
      param2.identifier = 'LOTEID';
      if (this.activedProject) {
        //La división de la propuesta de gasto
        param2.value = 0;
      } else {
        //La división del contrato
        param2.value = this.model.division.parent.identifier;
      }
      parametersURL.push(param2);

      let autoSearch = true;
      if (this.activedProject) {
        config['context'] = new SearchSettingDTOModal('BUDGETACCOUNTLINE_PROJECT_SEARCH', autoSearch, parametersURL);
      } else {
        config['context'] = new SearchSettingDTOModal('BUDGETACCOUNTLINE_CONTRACT_SEARCH', autoSearch, parametersURL);
      }
      let newRow: BudgetAccountLineDTO = new BudgetAccountLineDTO();
      let encontrado = false;
      const ref = this.dialogService.open(searchGenericComponent, config);
      this.subscribe(
        ref.onClose.pipe(
          tap((result: SearchSelectionResultDTO) => {
            if (result) {
              if (this.activedProject) {

                newRow.year = result.content.PRESUPANO.value;
                //newRow.exercise = result.content.EJERCICIO.value;
                newRow.organic = result.content.ANUORGANICA.value;
                newRow.functional = result.content.ANUFUNCIONAL.value;
                newRow.economical = result.content.ANUECONOMICA.value;
                newRow.investnmentProject = result.content.PROYINVID.value;
              } else {
                newRow.year = result.content.ANIO.value;
                //newRow.exercise = result.content.EJERCICIO.value;
                newRow.organic = result.content.ORGANICA.value;
                newRow.functional = result.content.FUNCIONAL.value;
                newRow.economical = result.content.ECONOMICA.value;
                newRow.investnmentProject = result.content.PROYECTO.value;
              }
              if (this.model.budget.budgetAccountLines !== null && this.model.budget.budgetAccountLines.length > 0) {
                this.model.budget.budgetAccountLines.forEach((budgetAccountLine: BudgetAccountLineDTO) => {
                  if (budgetAccountLine.year !== newRow.year
                    && budgetAccountLine.organic !== newRow.organic
                    && budgetAccountLine.functional !== newRow.functional
                    && budgetAccountLine.economical !== newRow.economical
                    && budgetAccountLine.investnmentProject !== newRow.investnmentProject) {
                    //encontrado = true;
                    //newRow = new BudgetAccountLineDTO();
                    return newRow;
                  }
                })
              } else {
                return newRow;
              }


            } else {
              console.log('Cerrado sin seleccionar');
            }
          }),
          catchError((error: any) => {
            this.plycaErrorHandler.showServerError(error);
            return throwError(error);
          })
        )
      );




      return newRow;



    } else {
      return new BudgetAccountLineDTO();
    }

  }

  public searchBudgetAccountLineSearch(newRow: BudgetAccountLineDTO) {
    let ret = false;
    if (this.model.budget.budgetAccountLines !== null && this.model.budget.budgetAccountLines.length > 0) {
      this.model.budget.budgetAccountLines.forEach((budgetAccountLine: BudgetAccountLineDTO) => {
        if (budgetAccountLine.year === newRow.year
          && budgetAccountLine.organic === newRow.organic
          && budgetAccountLine.functional === newRow.functional
          && budgetAccountLine.economical === newRow.economical
          && budgetAccountLine.investnmentProject === newRow.investnmentProject) {
          ret = true;
        }
      })
    }
    return ret;
  }


}
